import React, { useContext, useState } from 'react';
import { UserSessionContext } from 'src/context/UserSessionContext';
import { Navigate } from 'react-router-dom';
import { Box, Button, Container, TextField, Typography, useTheme } from '@mui/material';
import { useAlertSnackBar } from 'src/hooks/useAlertSnackBar';
import { AlertSnackBarSeverity } from 'src/constants';
import AlertSnackBar from 'src/components/AlertSnackBar/AlertSnackBar';
import { FadeInSection } from 'src/components/FadeInSection/FadeInSection';

export const ContactMe: React.FC<{ id: string }> = ({ id }) => {
  const { user, setUser } = useContext(UserSessionContext);
  const [userNameInput, setUserNameInput] = useState('');
  const [userEmailInput, setUserEmailInput] = useState('');
  const [messageBodyInput, setMessageBodyInput] = useState('');
  const theme = useTheme();
  const {
    alertSnackBarOpen,
    alertSnackBarDuration,
    alertSnackBarSeverity,
    alertSnackBarMessage,
    openAlertSnackBar,
    setAlertSnackBarOpen,
  } = useAlertSnackBar();

  const validateEmailContents = () => {
    if (typeof process.env.REACT_APP_GOOGLE_EMAIL === 'undefined') {
      return 'Email Server Error Encountered';
    }
    if (!userEmailInput.includes('@')) {
      return 'Please Input A Valid Email';
    }
    if (userNameInput.trim().length === 0) {
      return 'Please Input Your Name';
    }
    if (userEmailInput.trim().length === 0) {
      return 'Please Input Your Email';
    }
    if (messageBodyInput.trim().length === 0) {
      return 'Please Input A Message';
    }
    return '';
  };

  return (
    <Box
      id={id}
      sx={
        {
          // backgroundColor: theme.palette.primary.light,
        }
      }
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          justifyContent: 'center',
          gap: '16px',
          padding: '64px 10vw',
          overflow: 'hidden',
          maxWidth: '700px',
        }}
      >
        <FadeInSection>
          <Typography
            variant='h6'
            sx={{
              color: theme.extendedPalette.accent.main,
            }}
          >
            Let's Talk
          </Typography>
        </FadeInSection>
        <FadeInSection>
          <Typography
            variant='h5'
            sx={{ margin: '0 0 16px 0' }}
          >
            I'm excited to meet you!
          </Typography>
        </FadeInSection>
        <FadeInSection styles={{ width: '100%' }}>
          <TextField
            label='Your Name'
            fullWidth
            value={userNameInput}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setUserNameInput(event.target.value);
            }}
          />
        </FadeInSection>
        <FadeInSection styles={{ width: '100%' }}>
          <TextField
            label='Your Email'
            fullWidth
            value={userEmailInput}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setUserEmailInput(event.target.value);
            }}
          />
        </FadeInSection>
        <FadeInSection styles={{ width: '100%' }}>
          <TextField
            label="What's on your mind?"
            fullWidth
            multiline
            minRows={8}
            maxRows={14}
            value={messageBodyInput}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setMessageBodyInput(event.target.value);
            }}
          />
        </FadeInSection>
        <FadeInSection styles={{ width: '100%' }}>
          <Button
            fullWidth
            variant='contained'
            onClick={() => {
              // NOTE: was going to send a message the following way but came across two (maybe three) issues
              //      1) elasticemail is the only supported  SMTP host for the smtpjs library
              //      2) idk how to store api keys/secrets on the client side. I've searched everywhere and everyone says that the env variables can be viewable by everyone if they look into the html.
              //            I still need to figure out how to store api keys that need to be used on the frontend
              //            https://stackoverflow.com/questions/48699820/how-do-i-hide-an-api-key-in-create-react-app
              //            https://stackoverflow.com/questions/46838015/using-api-keys-in-a-react-app/46839021#46839021
              //            everyone is saying, it's standard practice to store the api-key/secret in the backend, make the api call in the backend, then send the results to the frontend.
              //              I'm still concerned with situations where there are js libraries that need the api key in the frontend such as https://github.com/googlemaps/js-api-loader
              //              - I was thinking of storing it in the backend then fetching it from the frontend it when necessary but then realized that it would still be visible to anyone viewing the website if they were to look in the network tab of the inspect developer tools
              //        EDIT FROM FUTURE ME: I realize the answer lies in Answer 2 of https://stackoverflow.com/a/46839021
              //              essentially, you can't prevent someone from finding out what your secret key is if you need to use it in the frontend. BUT what you can do is add restrictions to the api key (in the api service's admin panel) so that the only website that can make use of the api key is your website's ip address
              //              this is how you can restrict an api key for local development: https://support.woolpert.io/hc/en-us/articles/360062174734-How-should-I-restrict-my-API-Key-s-for-local-development-#:~:text=Here%20are%20a%20couple%20of,your%20application%20at%20this%20port.
              //              another good answer saying how you should have multiple api keys: one for production and one for local development
              //      3) i think this library only allows you to send emails using your own email.
              //          this isn't necessarily a problem now that I think about it. I thought to be able to get the person's email, I would need to make the email come from their email. but now that I think about it, I can just send an email using my own email address to that same email address using the smtp server. Then include the name, email, and message body in the email body that is sent to my email.
              // if (
              //   typeof process.env.REACT_APP_GOOGLE_USERNAME === 'undefined' ||
              //   typeof process.env.REACT_APP_GOOGLE_PASSWORD === 'undefined' ||
              //   typeof process.env.REACT_APP_GOOGLE_EMAIL === 'undefined'
              // ) {
              //   openAlertSnackBar(
              //     6000,
              //     AlertSnackBarSeverity.ERROR,
              //     'SMTP Server Error Occurred',
              //   );
              //   return;
              // }
              // window.Email.send({
              //   Host: 'smtp.gmail.com',
              //   Username: process.env.REACT_APP_GOOGLE_USERNAME,
              //   Password: process.env.REACT_APP_GOOGLE_PASSWORD,
              //   To: process.env.REACT_APP_GOOGLE_EMAIL,
              //   From: userEmailInput,
              //   Subject: `Personal Website Message From ${userNameInput}`,
              //   Body: messageBodyInput,
              // }).then((message: string) => console.log(message));
              // openAlertSnackBar(
              //   6000,
              //   AlertSnackBarSeverity.SUCCESS,
              //   'Message Sent Successfully',
              // );

              // NOTE: you wanted to try this way but you couldn't make it work bc you had to add names to the inputs that you couldn't remove from the email
              // built using:
              //   the html structure for sending emails as a form instead of mailto
              //      https://mailtrap.io/blog/javascript-send-email/
              //   how to create html structure using javascript
              //      https://stackoverflow.com/questions/50694881/how-to-download-file-in-react-js
              //      https://www.w3schools.com/js/js_htmldom_nodes.asp

              // const emailSubject = `Personal Website Message from ${userNameInput}`;
              // const emailIntro = `Hi David, my name is ${userNameInput}! I just wanted to get in contact with you about something I have detailed below.%0D%0A%0D%0AFeel free to contact me at ${userEmailInput}.`;
              // const emailBody = `${messageBodyInput}`;

              // // creating the form element
              // const emailForm = document.createElement('form');

              // // assigning values to the form properties
              // emailForm.action = `mailto:${process.env.REACT_APP_GOOGLE_EMAIL}?subject=${emailSubject}`;
              // emailForm.method = 'POST';
              // emailForm.enctype = 'text/plain';

              // // creating input elements and assigning form properties for the email body
              // const introLine = document.createElement('input');
              // introLine.type = 'text';
              // introLine.name = 'Introduction'; // tried to remove this bc it was causing an extra 'Introduction=' to be placed in email body, but a name is necessary for this element to even be recognized from the form
              // introLine.value = emailIntro;

              // const messageLine = document.createElement('input');
              // messageLine.type = 'text';
              // messageLine.name = 'Message';
              // messageLine.value = emailBody;

              // // creating submit input element that is used for submitting the form
              // const inputSubmit = document.createElement('input');
              // inputSubmit.type = 'submit';

              // // connecting form to the document body
              // document.body.appendChild(emailForm);

              // // nesting the inputs under the form
              // emailForm.appendChild(introLine);
              // emailForm.appendChild(messageLine)
              // emailForm.appendChild(inputSubmit);

              // // submitting the form
              // inputSubmit.click();

              // // clean up and remove the form
              // if (introLine.parentNode !== null) {
              //   introLine.parentNode.removeChild(introLine);
              // }
              // if (messageLine.parentNode !== null) {
              //   messageLine.parentNode.removeChild(messageLine);
              // }
              // if (inputSubmit.parentNode !== null) {
              //   inputSubmit.parentNode.removeChild(inputSubmit);
              // }
              // if (emailForm.parentNode !== null) {
              //   emailForm.parentNode.removeChild(emailForm);
              // }

              const emailContentsErrorMessage = validateEmailContents();
              if (emailContentsErrorMessage !== '') {
                openAlertSnackBar(
                  6000,
                  AlertSnackBarSeverity.ERROR,
                  emailContentsErrorMessage,
                );
                return;
              }

              const newlineCharacterEncoding = '%0D%0A';
              const emailSubject = `Personal Website Message from ${userNameInput}`;
              const emailIntro = `Hi David, my name is ${userNameInput}! I just wanted to get in contact with you about something I have detailed below.${newlineCharacterEncoding}${newlineCharacterEncoding}I'd love to get in touch! Please contact me at ${userEmailInput}. `;
              const emailBody = `${messageBodyInput}`;

              window.location.href = `mailto:${process.env.REACT_APP_GOOGLE_EMAIL}?subject=${emailSubject}&body=${emailIntro}${newlineCharacterEncoding}${newlineCharacterEncoding}${emailBody}`;
            }}
          >
            Send Message
          </Button>
        </FadeInSection>
        <AlertSnackBar
          openState={alertSnackBarOpen}
          toggleOpenState={() => {
            setAlertSnackBarOpen(!alertSnackBarOpen);
          }}
          duration={alertSnackBarDuration}
          severity={alertSnackBarSeverity}
          message={alertSnackBarMessage}
        />
      </Container>
    </Box>
  );
};

export default ContactMe;
